function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9366",
  "data-name": "Path 9366",
  d: "M402.682,2601.335a1.043,1.043,0,0,0,1.466.168l6.073-4.823c.039,3.874.067,8.82.007,9.563a1.043,1.043,0,0,0,1.79.932c.357-.4.357-.4.321-6.51-.009-1.43-.022-2.865-.033-3.937l6.035,4.8a1.043,1.043,0,0,0,1.3-1.633l-6.58-5.23a2.651,2.651,0,0,0-1.742-.718c-.024,0-.048-.007-.073-.007h-.013c-.017,0-.034,0-.051.006a2.654,2.654,0,0,0-1.775.719l-6.557,5.206A1.044,1.044,0,0,0,402.682,2601.335Z",
  transform: "translate(-401.198 -2593.938)",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9367",
  "data-name": "Path 9367",
  d: "M407.327,2651.263h-9.908v-3.948a1.043,1.043,0,0,0-2.086,0v4.991a1.045,1.045,0,0,0,1.043,1.043h11.048a7.881,7.881,0,0,1-.127-1.412C407.3,2651.71,407.306,2651.485,407.327,2651.263Z",
  transform: "translate(-395.333 -2634.14)",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9368",
  "data-name": "Path 9368",
  d: "M461.411,2644.951a5.971,5.971,0,1,0,5.971,5.971A5.978,5.978,0,0,0,461.411,2644.951Zm0,9.856a3.885,3.885,0,1,1,3.885-3.885A3.889,3.889,0,0,1,461.411,2654.807Z",
  transform: "translate(-441.918 -2633.126)",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_9369",
  "data-name": "Path 9369",
  d: "M475.719,2662.8l-.828-.11a.405.405,0,0,1-.309-.219l-.38-.745a.406.406,0,0,0-.729.009l-.36.754a.407.407,0,0,1-.3.226l-.825.131a.406.406,0,0,0-.217.7l.606.576a.406.406,0,0,1,.121.358l-.131.826a.406.406,0,0,0,.595.421l.735-.4a.406.406,0,0,1,.378,0l.745.38a.407.407,0,0,0,.584-.436l-.152-.822a.406.406,0,0,1,.112-.361l.591-.591A.407.407,0,0,0,475.719,2662.8Z",
  transform: "translate(-454.484 -2645.841)",
  fill: "black"
});

var SvgUploadArrow = function SvgUploadArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2270",
    "data-name": "Group 2270",
    width: 25.465,
    height: 23.768,
    viewBox: "0 0 25.465 23.768",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-arrow.c10d17dc.svg";
export { ForwardRef as ReactComponent };